// extracted by mini-css-extract-plugin
export default {"dashboard":"Dashboard_dashboard__CM5BJ","pageContent":"Dashboard_pageContent__j53Q0"};